/* File : src/components/common/Button.js */
import React from 'react';
import './Button.css'; // Nous créerons ce fichier de style plus tard

/**
 * Composant Bouton réutilisable qui respecte la charte graphique de Guinness
 * 
 * @param {Object} props - Propriétés du composant
 * @param {string} props.variant - Variante du bouton (primary, secondary, outline)
 * @param {string} props.size - Taille du bouton (sm, md, lg)
 * @param {boolean} props.fullWidth - Si le bouton prend toute la largeur disponible
 * @param {boolean} props.disabled - Si le bouton est désactivé
 * @param {Function} props.onClick - Fonction appelée lors du clic sur le bouton
 * @param {React.ReactNode} props.children - Contenu du bouton
 * @param {string} props.className - Classes CSS supplémentaires
 * @param {Object} props.rest - Autres propriétés à passer au bouton
 */
const Button = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  onClick,
  children,
  className = '',
  ...rest
}) => {
  // Déterminer les classes CSS en fonction des props
  const buttonClasses = [
    'guinness-btn',
    `guinness-btn-${variant}`,
    `guinness-btn-${size}`,
    fullWidth ? 'guinness-btn-full-width' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;